import { Button, Col, Row } from "antd";
import { join, slice } from "lodash";
import { FiTrash } from "react-icons/fi";
import { CustomAvatar } from "../../avatar/CustomAvatar";
import { useDirectoryContext } from "./DirectoryContext";

const BasicOrgInfo = ({ memberGroup }) => {
  const { onDeleteItem } = useDirectoryContext();

  const generatePath = (member) => {
    const pathName = join(
      slice(member?.paths, 0, member?.paths?.length)?.map(
        (paths) => paths?.name,
      ),
      ">",
    );

    return (
      <div key={`${member?.userId}_${pathName}`} className="org-name-chain">
        <span className="text-[#d33b3d] p-[2px]">*</span>
        {pathName}
      </div>
    );
  };

  return (
    <Row className="w-full mb-5 items-center">
      <Col
        xs={4}
        sm={4}
        md={4}
        lg={4}
        xl={2}
        className="flex items-center justify-center"
      >
        <CustomAvatar
          person={memberGroup?.[0]}
          userId={memberGroup?.[0]?.userCode}
          pos={-1}
          styleCss={{}}
          isShowUserStatus={{ status: true, isAlwaysTrue: false }}
        />
      </Col>
      <Col
        xs={17}
        sm={17}
        md={17}
        lg={17}
        xl={20}
        className="items-center justify-center"
      >
        <Row className="items-center text-sm">
          <Col xs={24} sm={24} md={24} lg={10}>
            <span className={"font-bold text-[14px]"}>
              {memberGroup?.[0]?.name || "DELETED MEMBER"}
            </span>
          </Col>
          <Col xs={24} sm={24} md={24} lg={14}>
            {memberGroup?.length > 0 ? (
              memberGroup?.map((member) => generatePath(member))
            ) : (
              <div className="flex items-center">
                <div className="text-[14px]">
                  <span className="text-[#d33b3d] p-[2px]">*</span>
                  <span>UNKNOWN GROUP</span>
                </div>
              </div>
            )}
          </Col>
        </Row>
      </Col>
      <Col
        xs={4}
        sm={4}
        md={4}
        lg={4}
        xl={2}
        className="flex flex-1 items-center justify-center text-[10px]"
      >
        <Button
          className="bg-[#e00d0d] text-[white]"
          onClick={() => onDeleteItem(memberGroup?.[0])}
          icon={<FiTrash className="text-[18px]" />}
        ></Button>
      </Col>
    </Row>
  );
};

export { BasicOrgInfo };
